import {
    PharmaciesModel
} from 'one-card-patient-pharmacy';

import {
    SET,
    REINIT
} from './types';

import {
    Actions,
} from './action';

export const patientpharmacy = (
    context: any,
    initial?: PharmaciesModel,
) => (
        (
            state: PharmaciesModel,
            action: Actions,
        ) => {
            const {
                type,
                payload,
            } = action;

            let updated = state || initial || {

            };
            switch (type) {
                case SET:
                    updated = {
                        ...payload,
                    }
                    break;
                case REINIT:
                    updated = {
                        ...initial
                    }
                    break;
            }
            return updated;
        }
    )